import { SessionTimeout } from '../pages/ErrorPages/SessionTimeout';

export function AppError(args: {
  authErrorMessage?: string | null;
  sessionErrorMessage?: string | null;
  onRetry: () => void;
}) {
  const { authErrorMessage, sessionErrorMessage, onRetry } = args;
  const message = `${authErrorMessage} ${sessionErrorMessage}`;
  return (
    <SessionTimeout
      type={(() => {
        if (/login_required/i.test(message)) {
          return 'timeout';
        }
        if (message === 'Unexpected environment') {
          return 'unexpectedEnvironment';
        }
        return 'unknown';
      })()}
      onRetry={onRetry}
    />
  );
}
